<template>

    <div class="mycontainer" v-if="tempId">
        <div class="headerclass">数据信息列表</div>
        <div class="keywordclass">
          <div class="keyword_item">
            <div class="searchtitle" >关键字：</div>
            <el-input v-model="keyword" maxlength="20" placeholder="请输入关键字"></el-input>
          </div>
          <div class="keyword_item">
            <div class="searchtitle">创建人：</div>
            <el-input v-model="userName" maxlength="20" placeholder="请输入创建人"></el-input>

          </div>
          <div class="keyword_item">
            <div class="searchtitle">更新时间：</div>
            <el-date-picker
              v-model="updateTime"
              type="year"
              format="yyyy"
              value-format="yyyy"
              placeholder="选择更新时间">
            </el-date-picker>
          </div>

          <div class="keyword_item">
            <div class="searchtitle">状态：</div>
            <el-select v-model="status" placeholder="请选择">
              <el-option
                v-for="item in statuslist"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="keyword_item">
            <div class="searchtitle">模板列表：</div>
            <el-select v-model="tempId" placeholder="请选择"  @change="tempSelect">
              <el-option
                v-for="item in tempIdList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <button class="submitclass" @click="getFormList">搜索</button>
          <!--<button class="submitclass" @click="insertDataList">新增</button>-->
        </div>
        <div class="tableclass" v-if="tabnamelist&&tabnamelist.length>0">
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="序号"
              type="index"
              header-align="center"
              align="center"
              width="80">
            </el-table-column>
            <el-table-column
              v-for="(item,index) in tabnamelist"
              :key="index"
              :prop="item.COLID"
              :label="item.COLNAME"
              show-overflow-tooltip
              width="180">
              <!--<template slot-scope="scope">-->
                <!--<span @click="enterpriseclick(scope.row)" class="overflow" style="cursor: pointer" slot="reference">{{scope.row.cust_name}}</span>-->
              <!--</template>-->
            </el-table-column>

            <el-table-column
              fixed="right"
              label="操作"
              width="150">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row.ID)" type="text" size="small">{{scope.row.SUBMIT=='1'?'查看':'编辑'}}</el-button>
                <el-button type="text" size="small" @click="deleteClick(scope.row.ID,scope.$index)" v-if="scope.row.SUBMIT!='1'">删除</el-button>
                <el-button type="text" size="small" @click="submitClick(scope.row.ID,scope.$index)" v-if="scope.row.SUBMIT!='1'">提交</el-button>
                <el-button type="text" size="small" @click="gobackClick(scope.row.ID,scope.$index)" v-if="scope.row.SUBMIT=='1'">{{getButton('button_01')?'退回':''}}</el-button>
              </template>
            </el-table-column>

          </el-table>
          <div class="pageclass" v-if="totalcount>0">
            <el-pagination
              @current-change="getFormList"
              background
              layout="total,sizes,prev, pager, next,jumper"
              :total="totalcount"
              :page-size="endPage"
              :page-sizes="[5,10, 15, 20]"
              @size-change="handleSizeChange"
              :current-page.sync="startPage"
            >
            </el-pagination>
          </div>

        </div>

      </div>

</template>

<script>
  import * as api from "../../utils/api"
  import axios from "axios";
  import HeaderCommon from '../../components/HeaderCommon'
  import LeftNav from '../../components/LeftNav'
  import ElInput from "element-ui/packages/input/src/input";

  export default {
    components: {
      ElInput,
      HeaderCommon,
      LeftNav
    },
    name: "data-collection-list",
    data(){
      return{
        keyword:'',
        userName:'',
        updateTime:'',//更新时间
        startPage:Number(this.$route.params.startPage),//当前页数
        endPage: 10,//当前页面个数
        totalcount: 0,//总个数
        tabnamelist:[],
        tableData: [],
        loading:false,
        statuslist: [{
          value: '',
          label: '全部'
        },{
          value: '0',
          label: '未提交'
        }, {
          value: '1',
          label: '已提交'
        }, {
          value: '2',
          label: '退回'
        }],
        status: '',
        tempIdList:[],
        tempId:'',//模板id
        collection:'',//跳转页面

      }
    },
    watch:{
      $route(){
        this.startPage=Number(this.$route.params.startPage);
        this.getFormList();
      },
      startPage(val){
        if(val == 1){
          let {name,params,query}=this.$route;
          this.$router.push({
            name,params:{
              startPage:1
            }
          })
        }
      }
    },
    mounted(){
      this.getUserTemp();
    },
    methods:{
       getButton(name) {
        var userButtonList= this.$store.state.userButtonList;
        for(var i =0 ;i<userButtonList.length;i++){
      if(userButtonList[i].permissionId==name){
        return true;
      }
    }
        return false;
        },
      getFormList() {

        this.loading=true;
        var self = this;
        api.getFormList({
          keyword:this.keyword,
          userName:this.userName,
          updateTime:this.updateTime,
          tempId:this.tempId,
          startPage: this.startPage,
          endPage: this.endPage,
          status:  this.status
        })
          .then(rs => {
            self.loading=false;

            // console.log(rs)
            if (rs.status == 200) {
              self.tabnamelist=rs.data.tabnamelist;
              self.tableData=rs.data.tableData;
              self.totalcount=Number(rs.data.count);

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })
      },
      getUserTemp(){
        var self = this;
        this.loading=true;

        api.getUserTemp({})
          .then(rs => {
            self.loading=false;

            // console.log(rs)
            if (rs.status == 200) {
              if(rs.data&&rs.data.length>0){
                rs.data.forEach(item=>{
                  self.tempIdList.push({
                    value:item.templateId,
                    label:item.templateName,
                    collection:item.collection
                  })
                })
                self.tempId=rs.data[0].templateId;
                self.collection=rs.data[0].collection;

                self.getFormList();
              }

            } else {

              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)

          })
      },
      //新增
      insertDataList(){
        this.$router.push({name:'datacollection'})
      },
      handleCurrentChange: function (val) {
        this.startPage = Number(`${val}`);
        this.getFormList();
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.endPage = Number(`${val}`);
        this.getFormList();
      },
      //编辑
      handleClick(formId){
        this.$router.push({
          name: this.collection,
          query:{
            formId:formId,
          }
        })
      },
      //删除
      deleteClick(formId,index){

        var self =this;
        this.$confirm('是否删除该数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          self.delForm(formId,index)
        }).catch(() => {

        });

      },
      //提交
      submitClick(formId,index){

        var self =this;
        this.$confirm('数据提交后将无法再次修改，请确认是否继续提交？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          self.submitForm(formId)
        }).catch(() => {

        });

      },
      submitForm(formId){

        var self =this;
        self.loading=true;

        api.submitForm({
          formId:formId
        })
          .then(rs =>{
            self.loading=false;
            if (rs.status == 200) {
              self.$message({
                message: '提交成功！',
                type: 'success'
              });
              self.getFormList();
            } else {
              self.$message.error(rs.message)
            }
          })
          .catch(err=>{
            self.$message.error(err)
            self.loading=false;

          })
      },

      //退回
      gobackClick(formId){
        var self =this;
        this.$confirm('是否将该数据退回？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          self.revoForm(formId)
        }).catch(() => {

        });
      },
      revoForm(formId){

        var self =this;
        self.loading=true;

        api.revoForm({
          formId:formId
        })
          .then(rs =>{
            self.loading=false;
            if (rs.status == 200) {
              self.$message({
                message: '退回成功！',
                type: 'success'
              });
              self.getFormList();
            } else {
              self.$message.error(rs.message)
            }
          })
          .catch(err=>{
            self.$message.error(err)
            self.loading=false;

          })
      },

      delForm(formId,index){

        var self =this;
        self.loading=true;

        api.delForm({
          formId:formId
        })
          .then(rs =>{
            self.loading=false;
            if (rs.status == 200) {
              self.$message({
                message: '删除成功！',
                type: 'success'
              });
              // self.tableData.splice(index,1)
              self.getFormList();

            } else {
              self.$message.error(rs.message)
            }
          })
          .catch(err=>{
            self.$message.error(err)
            self.loading=false;

          })
      },

      //根据关键字搜索企业
      accessOutApi(){

      },

      //高级搜索
      querySearchAsync(queryString, cb) {
        // console.log(queryString)
        // var restaurants = this.restaurants;
        // var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
        //
        // clearTimeout(this.timeout);
        // this.timeout = setTimeout(() => {
        //   cb(results);
        // }, 3000 * Math.random());
        if(queryString==''){
          cb([]);
          return;
        }

        api.accessOutApi({
          name:this.keyword
        })
          .then(rs => {

            if (rs.status == 200) {
              console.log(rs.data.items)
              rs.data.items.forEach(item=>{
                item.value=item.name
              })
              cb(rs.data.items);
            }else {

            }})
      },

      handleSelect(item) {
        // console.log(item);
        this.getFormList();
      },
      tempSelect(tempId){
        this.tempId=tempId;
         for(var i=0;i<this.tempIdList.length;i++){
           // con
           if(tempId==this.tempIdList[i].value){
             this.collection=this.tempIdList[i].collection;
             this.getFormList();
             break;
           }
         }
      }
    }
  }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>

  .mycontainer{
    background: #fff;
    width: 100%;
    min-height: calc(100vh - 70px);
    .headerclass{
      padding: 20px 0;
      margin: 0 20px;
      height: 15px;
      font-size: 16px;
      color: #2a3138;
      border-bottom: 1px solid #e6eaf0;
    }
    .tableclass{
      padding: 20px;
    }
    .keywordclass{
      display: flex;
      flex-wrap: wrap;
      padding: 0 20px;
      line-height: 40px;
      margin-top: 20px;
      .keyword_item{
        width: 400px;
        margin-bottom: 10px;
        display: flex;
        .searchtitle{
          width: 80px;
          text-align: right;
        }
        /deep/ .el-select > .el-input {
          width: 280px !important;
        }
      }
    span{
      color: #2a3138;
      font-size: 14px;
    }
      button{
        /*margin-left: 20px;*/
        margin-top: 3px;
      }
    }
  }

</style>
                                                                                                       



// WEBPACK FOOTER //
// src/views/collection/dataCollectionList.vue